import * as React from 'react';

class PenSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={`svg-icon pen-svg ${className || 'm-3'}`} {...rest}>
        <path
          d="M8.21222 1.61857L6.74972 0.774824C6.20972 0.465449 5.52347 0.651074 5.2141 1.18545L0.1516 9.95482C0.0447249 10.1404 -0.000275219 10.3373 0.00534978 10.5342V13.0486C0.00534978 13.3129 0.1516 13.5604 0.382225 13.6842C0.4891 13.7404 0.607225 13.7686 0.719725 13.7742C0.86035 13.7742 0.995349 13.7348 1.1191 13.6561L3.2116 12.2892C3.3466 12.1992 3.47035 12.0754 3.56035 11.9236L8.62285 3.1542C8.93222 2.61982 8.7466 1.92795 8.21222 1.61857ZM2.58722 11.3611L1.12472 10.5173L5.0566 3.71107L6.5191 4.55482L2.58722 11.3611ZM7.07597 3.5817L5.61347 2.73795L6.18722 1.74795L7.64972 2.5917L7.07597 3.5817Z"
          fill="#EA1C0A"
        />
      </svg>
    );
  }
}

export default PenSvg;
